export default __webpack_public_path__ + "static/media/Linkedin.6e4c04b3.svg";